import { render, staticRenderFns } from "./OtpSortControl.vue?vue&type=template&id=12ada28a&scoped=true"
import script from "./OtpSortControl.vue?vue&type=script&lang=js"
export * from "./OtpSortControl.vue?vue&type=script&lang=js"
import style0 from "./OtpSortControl.vue?vue&type=style&index=0&id=12ada28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ada28a",
  null
  
)

export default component.exports